export { default as DiscountBadgeTooltip } from './DiscountBadgeTooltip';
